import { z } from "zod";
import { MissionCommandSchema, MissionSourcesSchema } from "./mission-api.js";

export const CaptureDeliverySchema = z.object({
  artifacts: z.record(z.string(), z.string()),
  missionAttempt: z.number().int().nonnegative(),
  missionCommand: MissionCommandSchema.refine((command) => command.action === "sources").nullable(),
  complete: z.boolean(),
});
export const CaptureDraftSchema = z.object({
  id: z.string().regex(/^[a-z0-9-]+$/),
  apiBase: z.string(),
  userId: z.string(),
  fingerprint: z.string(),
  text: z.string().max(32000),
  files: z
    .array(
      z.object({
        key: z.string().regex(/^[a-z0-9-]+$/),
        name: z.string(),
        mimeType: z.string(),
        size: z.number(),
      }),
    )
    .max(11),
  references: MissionSourcesSchema,
  spaceId: z.string(),
  botId: z.string(),
  missionId: z.string().nullable(),
  started: z.boolean(),
  delivery: CaptureDeliverySchema,
});
export type CaptureDraft = z.infer<typeof CaptureDraftSchema>;

export type CaptureDelivery = z.infer<typeof CaptureDeliverySchema>;
